module.exports = __webpack_public_path__ + "img/IMAGE 3.8e6230b2.png";